module.exports = __webpack_public_path__ + "static/media/blue-blue.dd89872d.png";